import React, { useState } from "react";
import { Modal, Form, Input, Button, Space, message, notification } from "antd";
import strings from "../../utils/Localization";
import { useDispatch } from "react-redux";
import { setRerender } from "../../redux/actions/rerenderAction";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import useApi from "../../hooks/useApi";

const formSize = "middle";

function StokVaryantEkleModal({ visible = false, handleCancel }) {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const api = useApi();
  const { stokVaryantEkle: localization } = strings.stokVaryant.components;

  const onFinish = async (values) => {
    try {
      setFetchLoading(true);
      const { varyantAdi, varyantDeger } = values;

      let varyantDegerData = [];
      varyantDeger.map((item) => varyantDegerData.push({ ad: item.degerAdi }));

      const response = await api.post("/stokvaryant", {
        ad: varyantAdi,
        Stokvaryantdeger: varyantDegerData,
      });

      if (response.status === 200) {
        notification["success"]({
          message: strings.mesaj.basarliBaslik,
          description: strings.mesaj.islemBasarili,
        });
        form.resetFields();
        dispatch(setRerender());
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Modal
      title={localization.baslik}
      visible={visible}
      onCancel={handleCancel}
      handleCancel={handleCancel}
      okButtonProps={{
        htmlType: "submit",
        form: "varyantEkleModal",
        size: formSize,
        loading: fetchLoading,
      }}
      cancelButtonProps={{ size: formSize }}
    >
      <Form
        name="varyantEkleModal"
        form={form}
        onFinish={onFinish}
        layout="vertical"
        size={formSize}
        initialValues={{
          varyantAdi: "",
          varyantDeger: [
            {
              degerAdi: "",
            },
          ],
        }}
      >
        <Form.Item
          name="varyantAdi"
          label={localization.varyantAdi}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.List name="varyantDeger">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name }) => (
                <Space
                  key={key}
                  style={{ display: "flex", marginBottom: 8 }}
                  align="center"
                >
                  <Form.Item
                    name={[name, "degerAdi"]}
                    rules={[{ required: true }]}
                    label={localization.varyantDeger}
                  >
                    <Input placeholder={localization.degerGirinizPlaceHolder} />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  {localization.varyantDegerEkle}
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
}

export default StokVaryantEkleModal;
